<script lang="ts" setup>
import "@/styles/default.css";

import Vue from "vue";
import Constants from "./Constants";
import AUApi from "./api";
import { initLocalisation } from "./local";
import AppSnackBars from "./components/AppSnackBars.vue";
// import Navigation from "./components/Navigation.vue";

console.log("App.vue loaded");

AUApi.Current.init();
initLocalisation();
Constants.App = this as unknown as Vue.App;
// export default {
//   components: { Navigation },
// };
</script>
<template>
    <div class="container">
    <!-- <Navigation></Navigation> -->
    <router-view />
  </div>
</template>

<style>
@import '../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../node_modules/@syncfusion/ej2-vue-schedule/styles/material.css';
</style>
